import { FC } from 'react'
import { SegmentedControl } from '@cargomart/ui'
import cn from 'classnames'
import { formatCargoSize, formatCargoWeightGramToKilogram } from 'modules/order/helpers/formatCargo'

import CargoSizeControlDesktopElement from './CargoSizeControlDesktopElement'
import { CargoSizeControlProps } from './types'

export const CargoSizeControlDesktop: FC<CargoSizeControlProps<string>> = ({ cargoSize, onChange, value, invalid }) => (
  <SegmentedControl
    className="grid !h-auto grid-cols-[repeat(auto-fill,_minmax(11.429em,_1fr))] gap-3 py-2"
    onChange={onChange}
    value={value}
  >
    {cargoSize?.map((size) => (
      <CargoSizeControlDesktopElement
        key={size.id}
        className={cn(invalid && 'z-10 border border-negative')}
        value={size.id}
      >
        <div className="text-left">
          <div className="text-headline-sm">{size.name}</div>
          <div className="mr-6 text-body-md text-on-surface-variant">{size.description}</div>
        </div>
        <div className="text-left">
          <div className="text-body-md">до {formatCargoWeightGramToKilogram(size.weight)}</div>
          <div className="text-body-md">{formatCargoSize(size.length, size.width, size.height, false)}</div>
        </div>
      </CargoSizeControlDesktopElement>
    ))}
  </SegmentedControl>
)

export default CargoSizeControlDesktop
